"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Nav_1 = __importDefault(require("./Nav"));
var QueryLogHome_1 = __importDefault(require("components/modules/query-log/home/QueryLogHome"));
var AddQuery_1 = __importDefault(require("../modules/query-log/add-query/AddQuery"));
var QueryDetails_1 = __importDefault(require("../modules/query-log/query-details/QueryDetails"));
var navState_1 = require("../../contexts/navState");
var use_nav_state_1 = require("hooks/use-nav-state");
var Root = function () {
    var navState = use_nav_state_1.useNavState();
    var toggleHandler = function () {
        navState.saveState(navState.state === navState_1.NavState.NOT_COLLAPSED ?
            navState_1.NavState.COLLAPSED :
            navState_1.NavState.NOT_COLLAPSED);
    };
    return (react_1.default.createElement("div", { className: "root flex flex-row" },
        react_1.default.createElement(Nav_1.default, { collapsed: navState.state, onCollapseToggle: toggleHandler }),
        react_1.default.createElement("div", { className: "root__routes", "data-nav-collapsed": navState.state === navState_1.NavState.COLLAPSED },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: "/query/:id", component: QueryDetails_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/", component: QueryLogHome_1.default })),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/add-query", component: AddQuery_1.default }))));
};
exports.default = Root;
